import { Option, Select } from "@deere/fuel-react";
import { Dispatch } from "react";
import { useTranslation } from "react-i18next";
import {
  OrdersByLineItemActions,
  setFilterAction,
} from "../../reducers/actions";
import { LineStatus, OrdersByLineItemFilter } from "../../types";

type OrdersByLineItemLineStatusFilterProps = {
  filters: OrdersByLineItemFilter;
  dispatch: Dispatch<OrdersByLineItemActions>;
  tabIndex?: number;
};

const OrdersByLineItemLineStatusFilter = ({
  filters,
  dispatch,
  tabIndex,
}: OrdersByLineItemLineStatusFilterProps) => {
  const { t } = useTranslation("orders");

  const isDisabled = tabIndex !== undefined && tabIndex >= 1 && tabIndex <= 5;

  const getValue = () => {
    if (tabIndex === undefined) {
      return filters.lineStatus ?? Object.values(LineStatus);
    }

    switch (tabIndex) {
      case 0:
        return filters.lineStatus ?? Object.values(LineStatus);
      case 1:
        return [LineStatus.BACK_ORDERED];
      case 2:
        return [LineStatus.ON_HOLD];
      case 3:
        return [
          LineStatus.DEERE_INVESTIGATION,
          LineStatus.DEALER_INVESTIGATION,
        ];
      case 4:
        return [LineStatus.SENT_TO_SUPPLIER];
      case 5:
        return [LineStatus.SENT_TO_FACTORY];
      default:
        return filters.lineStatus ?? Object.values(LineStatus);
    }
  };

  return (
    <Select
      hasSearch={!isDisabled}
      hasSelectAll={!isDisabled}
      defaultChecked={!isDisabled}
      id="orders-by-lineItem-dropdown-value"
      data-testid="orders-by-lineItem-dropdown-value"
      multiple
      disabled={isDisabled}
      value={getValue()}
      onChange={(event) => {
        const { selectedOptions } = event.target;
        const values = Array.from(
          selectedOptions,
          (option) => option.value as LineStatus
        );
        dispatch(setFilterAction({ ...filters, lineStatus: values }));
      }}
    >
      {Object.values(LineStatus).map((value) => (
        <Option
          key={value}
          value={value}
          data-testid={`line-status-filter-dropdown-${value}`}
        >
          {t(`lineStatus.${value}`)}
        </Option>
      ))}
    </Select>
  );
};

export default OrdersByLineItemLineStatusFilter;
